/* eslint-disable react-hooks/exhaustive-deps */
import {Button, Flex, Select, TextInput, Transition} from "@mantine/core";
import {useForm} from "@mantine/form";
import {Dispatch, SetStateAction, useEffect, useState} from "react";
import {Company, CompanyAPI} from "../../api/company/CompanyAPI";

export type DeviceFilterAttrs = {
    isOpen: boolean;
    query: string;
    doUpdate: (query: string, payment: string) => void;
    companyId: string | null;
    setCompanyId: Dispatch<SetStateAction<string | null>>;
}

function DeviceFilter(attrs: DeviceFilterAttrs) {
    const form = useForm({
        mode: 'uncontrolled',
        initialValues: { query: '', payment: '' }
    });

    const [companyList, setCompanyList] = useState<Company[]>([]);

    // const reload = () => {
    //     form.setValues({
    //         query: attrs.query,
    //         payment: ''
    //     });
    // }

    const doSubmit = (values: any) => {
        attrs.doUpdate(values.query, values.payment);
    }

    // useEffect(reload, [attrs.query]);
    useEffect(() => {
      CompanyAPI.listAsync().then(setCompanyList);
    }, []);

    return (
        <Transition mounted={attrs.isOpen} transition="pop">
            { styles =>

                <form onSubmit={form.onSubmit(doSubmit)} style={styles}>
                    <Flex direction="row" align="center" gap={'md'}>
                        <TextInput
                            placeholder="Zapytanie"
                            key={form.key('query')}
                            {...form.getInputProps('query')}
                        />

                        <TextInput
                            placeholder="Płatność"
                            key={form.key('payment')}
                            {...form.getInputProps('payment')}
                        />

                      <Select
                        value={attrs.companyId}
                        placeholder="Wybierz firmę"
                        data={companyList.map(company => ({label: company.title, value: company.id}))}
                        onChange={(id: string | null) => {
                          attrs.setCompanyId(id);
                        }}
                      />

                        <Button type="submit">
                            Szukaj
                        </Button>
                    </Flex>
                </form>
            }
        </Transition>
    );
}

export default DeviceFilter;
